import OTPInput from "UIPalette/OTPInput/OTPInput";
import { useTranslation } from "react-i18next";

export const Verify = ({ handleChangeOtp }: { otp: string; handleChangeOtp: (_otp: string) => void }) => {
  const { t } = useTranslation(undefined, { keyPrefix: "accountSecurity.twoFactorAuth.verify" });

  return (
    <div className="space-y-6 lg:space-y-8">
      <div>
        <h2>{t("title")}</h2>
        <p>{t("description")}</p>
      </div>
      <OTPInput handleChange={handleChangeOtp} />
    </div>
  );
};
